/**
 * Frontend JavaScript für Parking Overview Block
 */

document.addEventListener('DOMContentLoaded', function () {
    // Alle Filter-Container auf der Seite
    const filterContainers = document.querySelectorAll('.parking-filter');

    filterContainers.forEach(filterContainer => {
        const buttons = filterContainer.querySelectorAll('.parking-filter__button');
        const block = filterContainer.closest('.parking-overview-block');
        const cards = block.querySelectorAll('.parking-card');
        const grid = block.querySelector('.parking-grid');
        const noResults = block.querySelector('.parking-no-results');

        buttons.forEach(button => {
            button.addEventListener('click', function () {
                const selectedType = this.dataset.filter;

                // Aktiven Button aktualisieren
                buttons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');

                let visibleCount = 0;

                // Karten filtern
                cards.forEach(card => {
                    const cardTypes = card.dataset.types || '';

                    if (selectedType === '' || cardTypes.includes(selectedType)) {
                        card.style.display = '';
                        card.removeAttribute('aria-hidden');
                        visibleCount++;
                    } else {
                        card.style.display = 'none';
                        card.setAttribute('aria-hidden', 'true');
                    }
                });

                // "Keine Ergebnisse" Meldung anzeigen/verstecken
                if (visibleCount === 0) {
                    if (grid) grid.style.display = 'none';
                    if (noResults) noResults.style.display = 'block';
                } else {
                    if (grid) grid.style.display = '';
                    if (noResults) noResults.style.display = 'none';
                }

                // Live-Region für Screenreader-Feedback
                announceFilterResults(block, visibleCount, cards.length);
            });
        });
    });

    // Hilfsfunktion für Screenreader-Ankündigungen
    function announceFilterResults(block, visibleCount, totalCount) {
        let liveRegion = block.querySelector('.filter-live-region');

        if (!liveRegion) {
            liveRegion = document.createElement('div');
            liveRegion.className = 'filter-live-region';
            liveRegion.setAttribute('role', 'status');
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            liveRegion.style.position = 'absolute';
            liveRegion.style.left = '-10000px';
            liveRegion.style.width = '1px';
            liveRegion.style.height = '1px';
            liveRegion.style.overflow = 'hidden';
            block.appendChild(liveRegion);
        }

        if (visibleCount === 0) {
            liveRegion.textContent = 'Keine Parkflächen gefunden, die den Filterkriterien entsprechen.';
        } else if (visibleCount === totalCount) {
            liveRegion.textContent = `Alle ${totalCount} Parkflächen werden angezeigt.`;
        } else {
            liveRegion.textContent = `${visibleCount} von ${totalCount} Parkflächen werden angezeigt.`;
        }
    }
});